import type { FaireProductEntity } from "../../entity_types/product";

export const p_jrqkfreea8: FaireProductEntity = {
  token: "p_jrqkfreea8",
  type: "product",
  name: "CONTRAST COLLAR OVERSIZED FAUX FUR JACKET",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/1b4dfa4cf3247ae01f61a6312553008746dec540cac4abb1cddf50d402d0667b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/295b2772c0f7e5f452d8d618a67e5967b849edfe84c25fb3579e48b6b1d8ef54.jpeg",
    "https://cdn.faire.com/fastly/5aa1e78bd257080ad0b33cb6584f80849f7d794a09ee7a5b4142366f720c885e.jpeg",
    "https://cdn.faire.com/fastly/63e6a923019f180004be7bdb00e3e35e1589977d191ef8b0b1100fb594639383.jpeg",
    "https://cdn.faire.com/fastly/65152e348ac9a11b813dc743d2e3737cb1ffe1d10c4967a795606cf6d4544f5e.jpeg",
    "https://cdn.faire.com/fastly/9af14ab591308fc04b5dda1a585dd4057fa140c37a414a0eb424e80efd8c5a87.jpeg",
    "https://cdn.faire.com/fastly/a19373b946ef10e2edafca471cb12c8c1443d67d03702acdcc9ea11c2d3f8413.jpeg",
    "https://cdn.faire.com/fastly/1eeb5140a794c6cb5eafe0b1023d7a56bd09b4425ecf7df69f73969388edf6bd.jpeg",
    "https://cdn.faire.com/fastly/263bdd227b1adcfc63a84e3e87c263e1cb50dd9e2f1d71bb104bda8b95a0eb6b.jpeg",
  ],
  priceDollars: 354,
  description:
    'MODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32B\nWAIST: 24"\nHIPS: 34"',
  tags: [],
  msrpDollars: 708,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:18.881Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
